/* ─────────────────────────────────────────────────────────────────────────
   Vinanest — cookie consent banner (self-contained, on-brand).
   Shows once per visitor; stores choice in localStorage and (if available)
   calls Shopify's Customer Privacy API so consent flows to analytics/marketing.
   ───────────────────────────────────────────────────────────────────────── */
(function(){
  if (window.__vnCookieLoaded) return; window.__vnCookieLoaded = true;
  var KEY = "vinanest_cookie_consent";
  var saved = null; try { saved = localStorage.getItem(KEY); } catch(e){}
  if (saved) return;  // visitor already chose

  function lang(){
    var l = (typeof currentLang !== "undefined" && currentLang) ||
            (function(){ try { return localStorage.getItem("vinanest_lang"); } catch(e){ return null; } })() ||
            document.documentElement.lang || "en";
    return String(l).indexOf("vi") === 0 ? "vi" : "en";
  }
  var T = {
    text:    { en: "We use cookies to improve your experience, measure traffic, and for marketing.", vi: "Chúng tôi dùng cookie để cải thiện trải nghiệm, đo lường lưu lượng và tiếp thị." },
    accept:  { en: "Accept all",      vi: "Chấp nhận tất cả" },
    decline: { en: "Necessary only",  vi: "Chỉ cookie cần thiết" },
    policy:  { en: "Privacy policy",  vi: "Chính sách bảo mật" }
  };
  function setConsent(granted){
    try { localStorage.setItem(KEY, granted ? "granted" : "denied"); } catch(e){}
    try {
      if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent){
        Shopify.customerPrivacy.setTrackingConsent({ analytics: granted, marketing: granted, preferences: granted, sale_of_data: granted }, function(){});
      }
    } catch(e){}
  }
  function build(){
    var css =
      '.vncook{position:fixed;left:50%;bottom:18px;transform:translateX(-50%);z-index:1200;width:min(680px,calc(100vw - 28px));background:#faf6ef;border:1px solid rgba(178,147,90,.5);border-radius:12px;box-shadow:0 30px 70px -28px rgba(60,42,28,.6);padding:15px 18px;display:flex;align-items:center;gap:16px;flex-wrap:wrap;font-family:"Be Vietnam Pro",-apple-system,system-ui,sans-serif}'+
      '.vncook-t{flex:1;min-width:210px;font-size:13px;line-height:1.5;color:#2a2520}'+
      '.vncook-t a{color:#7c2b2b;text-decoration:underline}'+
      '.vncook-btns{display:flex;gap:9px;flex-shrink:0}'+
      '.vncook-btn{font:inherit;font-size:12.5px;font-weight:600;letter-spacing:.02em;padding:10px 16px;border-radius:30px;cursor:pointer;transition:.2s;border:1px solid #7c2b2b}'+
      '.vncook-acc{background:#7c2b2b;color:#faf6ef}.vncook-acc:hover{background:#5f1f1f}'+
      '.vncook-dec{background:transparent;color:#7c2b2b}.vncook-dec:hover{background:rgba(124,43,43,.08)}'+
      '@media(max-width:560px){.vncook{bottom:10px;padding:14px}.vncook-btns{width:100%}.vncook-btn{flex:1}}';
    var st = document.createElement("style"); st.textContent = css; document.head.appendChild(st);
    var bar = document.createElement("div");
    bar.className = "vncook"; bar.setAttribute("role","dialog"); bar.setAttribute("aria-label","Cookie consent");
    bar.innerHTML = '<div class="vncook-t"></div><div class="vncook-btns"><button type="button" class="vncook-btn vncook-dec"></button><button type="button" class="vncook-btn vncook-acc"></button></div>';
    var t = bar.querySelector(".vncook-t");
    t.textContent = T.text[lang()] + " ";
    var a = document.createElement("a"); a.href = "/policies/privacy-policy"; a.setAttribute("target","_top"); a.textContent = T.policy[lang()];
    t.appendChild(a);
    bar.querySelector(".vncook-dec").textContent = T.decline[lang()];
    bar.querySelector(".vncook-acc").textContent = T.accept[lang()];
    bar.querySelector(".vncook-acc").onclick = function(){ setConsent(true); bar.remove(); };
    bar.querySelector(".vncook-dec").onclick = function(){ setConsent(false); bar.remove(); };
    document.body.appendChild(bar);
  }
  if (document.body) build(); else document.addEventListener("DOMContentLoaded", build);
})();
